/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CompliancePolicyDataCleanUpRequest {
    getFixupPrototypeFunction() { return CompliancePolicyDataCleanUpRequest.fixupPrototype; }

    static newInstance(model: Partial<CompliancePolicyDataCleanUpRequest>): CompliancePolicyDataCleanUpRequest {
        let obj = Object.assign(new CompliancePolicyDataCleanUpRequest(), model);
        CompliancePolicyDataCleanUpRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CompliancePolicyDataCleanUpRequest>): CompliancePolicyDataCleanUpRequest {
        if (!model) return null;
        return CompliancePolicyDataCleanUpRequest.newInstance(<CompliancePolicyDataCleanUpRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CompliancePolicyDataCleanUpRequest) {
        if (!obj) return;

        models.CompliancePolicyDataCleanUpRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CompliancePolicyDataCleanUpRequest): boolean {
        Object.setPrototypeOf(obj, CompliancePolicyDataCleanUpRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Compliance Policy uris
     */
    policy_uris: Array<string>;

}
